import axiosInstance from "./AxiosInstance";

export function getSearchVehicleListDropdownList(data) {
  return axiosInstance.post(
    `/vehicle-process/get-search-vehicle-list-dropdown`,
    data
  );
}

export function getSearchPartReferenceListDropdownList(data) {
  return axiosInstance.post(`/part-reference-list-dropdown`, data);
}

export function getVehicleMakesSearchDropdownList(data) {
  return axiosInstance.post(`/vehicle-make/search-list-dropdown`, data);
}

export function getVehicleModelSearchDropdownList(data) {
  return axiosInstance.post(`/vehicle-model/search-list-dropdown`, data);
}

export function getVehicleVariantsSearchDropdownList(data) {
  return axiosInstance.post(`/vehicle-variants/search-list-dropdown`, data);
}

export function getCatalogSearchDropdownList(data) {
  return axiosInstance.post(`/catalog-search-list-dropdown`, data);
}

export function getVehicleEngineSearchManufacturerDropdownList(data) {
  return axiosInstance.post(
    `/vehicle-engine/search-manufacturer-engine-list`,
    data
  );
}




